
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { findByChainId } from 'chain-list';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { useEffect } from 'react';
import Button from '../../components/Button';
import FiatNumber from '../../components/FiatNumber';
import IconContainer from '../../components/icons/IconContainer';
import NumberFormat from '../../components/NumberFormat';
import Page from '../../components/Page';
import getServerSideProps from '../../utils/liquidityPoolsServerProps';
const percentageDecimals = parseInt(process.env.NEXT_PUBLIC_UI_PERCENT_DECIMALS) || 2;
const ViewSwitcher = function ({ listView }) {
    const router = useRouter();
    return (<div className="bg-blue-primary mb-8 hidden w-auto space-x-4 rounded-md p-1 md:inline-flex">
      <button className={`flex w-20 justify-center rounded py-1 ${listView ? '' : 'bg-gray-6'}`} onClick={function (e) {
            e.preventDefault();
            router.push({
                query: {
                    ...router.query,
                    view: 'box'
                }
            }, undefined, {
                shallow: true
            });
        }} type="button">
        <IconContainer fill={listView ? '#656774' : '#F8F8F9'} name="boxview"/>
      </button>
      <button className={`flex w-20 justify-center rounded py-1 ${listView ? 'bg-gray-6' : ''}`} onClick={function (e) {
            e.preventDefault();
            router.push({
                query: {
                    ...router.query,
                    view: 'list'
                }
            }, undefined, {
                shallow: true
            });
        }} type="button">
        <IconContainer fill={listView ? '#F8F8F9' : '#656774'} name="listview"/>
      </button>
    </div>);
};
const BoxView = function ({ liquidityPools }) {
    const { t } = useTranslation();
    return (<div className="flex flex-wrap md:grid md:grid-cols-3 md:gap-8">
      {liquidityPools.map(function ({ apy = 0, chainId, href, protocol: { name }, pair, tvl }, i) {
            const chain = findByChainId(chainId);
            const icons = pair.split('-');
            return (<div className="bg-blue-primary mb-8 w-full rounded-lg" key={i}>
            <div className={`bg-${name.toLowerCase()} relative h-20 rounded-t-lg px-4 pt-3`}>
              <div className="bg-white-05 inline-flex items-center space-x-3 rounded p-2 text-sm text-white">
                <span>{chain.standardName}</span>
                <div className="bg-white-2 rounded-sm p-1">
                  <IconContainer className="h-4 w-4" name={chain.shortName}/>
                </div>
              </div>
              <div className="bg-white-05 absolute -bottom-5 rounded-full p-2">
                <IconContainer name={name.toLowerCase()}/>
              </div>
            </div>
            <div className="space-y-4 px-4 pb-6 pt-8 ">
              <div className="flex items-center space-x-2 font-bold text-white">
                <div className="flex -space-x-2">
                  {icons.map((icon, i) => (<IconContainer key={i} name={icon.toLowerCase().split(' ')[0]}/>))}
                </div>
                <span>{pair}</span>
              </div>
              <div className="bg-blue-tertiary/50 w-full rounded-lg">
                <div className="text-gray-primary flex justify-between px-4 py-2">
                  <div>APY</div>
                  <div>TVL</div>
                </div>
                <div className="flex justify-between px-4 py-2 text-lg text-white">
                  <NumberFormat decimals={percentageDecimals} suffix="%" value={apy}/>
                  <div>
                    <FiatNumber decimals={0} value={tvl}/>{' '}
                  </div>
                </div>
              </div>
              <Button className="block w-full text-center text-sm font-bold" href={href} size="lg">
                {t('actions.deposit')}
              </Button>
            </div>
          </div>);
        })}
    </div>);
};
const ListView = function ({ liquidityPools }) {
    const { t } = useTranslation();
    return (<div className="lg:bg-block text-white lg:w-full lg:rounded-md lg:p-6 lg:pt-4">
      <div className="hidden p-5 text-sm font-bold capitalize lg:flex">
        <div className="lg:w-1/6">{t('liquidity-pools.pool')}</div>
        <div className="w-1/6">{t('liquidity-pools.chain')}</div>
        <div className="w-1/6">{t('liquidity-pools.protocol')}</div>
        <div className="w-1/6">APY</div>
        <div className="w-1/6">TVL</div>
        <div className="w-1/6 text-center">{t('liquidity-pools.actions')}</div>
      </div>
      <div className="lg:bg-blue-secondary space-y-4 lg:w-full lg:space-y-11 lg:rounded-lg lg:p-4">
        {liquidityPools.map(function ({ apy = 0, chainId, href, protocol: { name, standardName }, pair, tvl }, i) {
            const chain = findByChainId(chainId);
            const icons = pair.split('-');
            return (<div className="bg-blue-secondary w-full rounded-lg p-4 lg:flex lg:rounded-none lg:bg-transparent lg:p-0" key={i}>
              <div className="bg-blue-6 mb-0.5 flex items-center space-x-4 rounded-lg px-3 py-2 text-sm lg:mb-0 lg:w-1/6 lg:rounded-none lg:bg-transparent lg:p-0">
                <div className="flex -space-x-2">
                  {icons.map((icon, i) => (<IconContainer key={i} name={icon.toLowerCase()}/>))}
                </div>
                <span>{pair}</span>
              </div>
              <div className="flex w-1/6  text-xs lg:text-base">
                <div className="flex items-center space-x-4">
                  <div className="text-gray-secondary lg:hidden lg:text-white">
                    {t('liquidity-pools.chain')}
                  </div>
                  <div className="flex items-center space-x-4">
                    <IconContainer className="h-6 w-6" name={chain.shortName}/>
                    <span>{chain.standardName}</span>
                  </div>
                </div>
              </div>
              <div className="flex w-1/6 justify-between text-xs lg:text-base">
                <div className="text-gray-secondary lg:hidden lg:text-white">
                  {t('liquidity-pools.protocol')}
                </div>
                <div className="flex items-center space-x-4">
                  <IconContainer name={name}/>
                  <span>{standardName}</span>
                </div>
              </div>
              <div className="flex w-1/6 items-center">
                <NumberFormat decimals={percentageDecimals} suffix="%" value={apy}/>
              </div>
              <div className="flex w-1/6 items-center">
                <FiatNumber decimals={0} value={tvl}/>
              </div>
              <div className="flex w-1/6 items-center">
                <Button className="text-center text-sm" href={href} size="lg">
                  {t('actions.deposit')}
                </Button>
              </div>
            </div>);
        })}
      </div>
    </div>);
};
export default function LiquidityPools({ hasError, liquidityPools }) {
    const { t } = useTranslation();
    const router = useRouter();
    const boxView = router.query.view === 'box';
    const listView = router.query.view === 'list';
    useEffect(function () {
        if (!boxView && !listView) {
            router.push({
                query: {
                    ...router.query,
                    view: 'box'
                }
            }, undefined, {
                shallow: true
            });
        }
    });
    return (<Page hasError={hasError} title={t('navigation.liquiditypools')}>
      <h2 className="mb-4 mt-4 text-2xl font-semibold leading-7 text-white">
        {t('liquidity-pools.title')}
      </h2>
      <p className="mb-8 text-gray-500">{t('liquidity-pools.description')}</p>
      <ViewSwitcher listView={listView}/>
      {listView && <ListView liquidityPools={liquidityPools}/>}
      {(!boxView && !listView) || boxView ? (<BoxView liquidityPools={liquidityPools}/>) : null}
    </Page>);
}
export {};

    async function __Next_Translate__getServerSideProps__1a0f35fc50c__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[shortName]/liquidity-pools',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a0f35fc50c__ as getServerSideProps }
  